// extracted by mini-css-extract-plugin
export default {"input":"Input_input__k5Ctk","error":"Input_error__1wKFK"};